export default __webpack_public_path__ + "static/media/ryans.54751a12.jpg";